import React, { useEffect } from 'react';
import { Form, Button, Col, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createBoxFolderOfEmp } from '../../../../services/BoxFolderOfEmpService';
import AsyncSelect from 'react-select/async';
import { getUsersSearch } from '../../../../services/BoxService';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { connect, useDispatch } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  folderId: Yup.string().required('Folder ID is required'),
});

const AddBoxFolderOfEmp = ({ employeeList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await createBoxFolderOfEmp(values);
      // Show success toast notification
      toast.success('Box Folder Added Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/box-folders/');
      }, 3000);
    } catch (error) {
      console.error('Error adding Box Folder of Emp', error);
    } finally {
      setSubmitting(false);
    }
  };

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  return (
    <div>
      <Card>
        <h2>Add Box Folder of Emp</h2>
        <Formik
          initialValues={{ email: '', folderId: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, handleSubmit, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <Form.Group as={Col} controlId="email">
                    <Form.Label>Employee</Form.Label>
                    <Field name="email">
                      {({ field }) => (
                        <AsyncSelect
                          {...field}
                          value={employeeList.find((e) => e.value === values.email)}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={employeeList}
                          placeholder="Select employee..."
                          className="react-select-container"
                          classNamePrefix="react-select"
                          onChange={(selectedOption) => {
                            setFieldValue('email', selectedOption.email);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage name="email" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="folderId">
                    <Form.Label>Folder ID</Form.Label>
                    <Field name="folderId" as={Form.Control} type="text" />
                    <ErrorMessage name="folderId" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button className="m-2" variant="primary" type="submit" disabled={isSubmitting}>
                  Add Folder
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps, {})(AddBoxFolderOfEmp);
